import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("carousel", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("carousel")
      ) {
        return {
          type: "carousel",
        };
      }
    },
    model: {
      defaults: {
        tagName: "div",
        classes: ["carousel"],
        traits: [
          {
            type: "checkbox",
            label: "Autoplay",
            name: "autoplay",
            valueTrue: "YES",
            valueFalse: "NO",
          },
        ],
        components: /*html*/ `
        <section class="w-full md:h-[60vh] h-[50vh] mt-4">
        <div class="w-full bg-white rounded-lg overflow-hidden md:rounded-none flex items-center justify-center h-full md:hidden">
          <div class="swiper MySwiper h-full ">
            <div class="swiper-wrapper h-full">
              <div class="swiper-slide flex items-center justify-center h-full ">
                <div class="h-full w-full">
                  <img src="https://via.placeholder.com/100" alt="hero-image" class="object-contain h-full w-full" />
                </div>
              </div>
              <div class="swiper-slide flex items-center justify-center h-full">
                <div class="h-full w-full">
                  <img src="https://via.placeholder.com/100" alt="hero-image" class="object-contain h-full w-full" />
                </div>
              </div>
              <div class="swiper-slide flex items-center justify-center h-full">
                <div class="h-full w-full">
                  <img src="https://via.placeholder.com/100" alt="hero-image" class="object-contain h-full w-full" />
                </div>
              </div>
              <div class="swiper-slide flex items-center justify-center h-full">
                <div class="h-full w-full">
                  <img src="https://via.placeholder.com/100" alt="hero-image" class="object-contain h-full w-full" />
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="w-full bg-white rounded-lg overflow-hidden md:rounded-none flex items-center justify-center h-full hidden md:block">
          <div class="swiper MySwiper h-full ">
            <div class="swiper-wrapper h-full">
              <div class="swiper-slide flex items-center justify-center h-full ">
                <div class="h-full w-full ">
                  <img src="https://via.placeholder.com/100" alt="hero-image" class="object-contain h-full w-full" />
                </div>
              </div>
              <div class="swiper-slide flex items-center justify-center h-full">
                <div class="h-full w-full">
                  <img src="https://via.placeholder.com/100" alt="hero-image" class="object-contain h-full w-full" />
                </div>
              </div>
              <div class="swiper-slide flex items-center justify-center h-full">
                <div class="h-full w-full">
                  <img src="https://via.placeholder.com/100" alt="hero-image" class="object-contain h-full w-full" />
                </div>
              </div>
              <div class="swiper-slide flex items-center justify-center h-full">
                <div class="h-full w-full">
                  <img src="https://via.placeholder.com/100" alt="hero-image" class="object-contain h-full w-full" />
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </section>
        `,
        script: function () {
          const autoplayEnabled = this.getAttribute("autoPlay") === "YES";
          const initLib = function () {
            //@ts-ignore
            const swiper = new Swiper(".MySwiper", {
              direction: "horizontal",
              slidesPerView: 1,
              centeredSlides: true,
              spaceBetween: 30,
              autoplay: autoplayEnabled
                ? {
                    delay: 2500,
                    disableOnInteraction: false,
                  }
                : false,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            });
          };
          //@ts-ignore
          if (typeof Swiper === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
